import client from '@/api/client'

export async function getGoalTrackingStatus(questionType) {
    return client.get(`/goals/trackingstatus/${questionType}`)
}
